import React from "react";
import chapter_1 from "../../../Assets/Images/About/about-bg-02.png";
import chapter_2 from "../../../Assets/Images/About/about-bg-03.png";
import chapter_3 from "../../../Assets/Images/About/about-bg-04.png";
import chapter_4 from "../../../Assets/Images/About/about-bg-05.png";
import { useTranslation } from "react-i18next";
import "./style.scss";

function Chapters() {
  const { t } = useTranslation();
  const dataChapter = [
    {
      img: chapter_1,
      title: t("chapters.chapter1.title"),
      subtitle: t("chapters.chapter1.subtitle"),
      detail: t("chapters.chapter1.detail"),
      darkColor: false,
    },
    {
      img: chapter_2,
      subtitle: t("chapters.chapter2.subtitle"),
      detail: t("chapters.chapter2.detail"),
      darkColor: false,
    },
    {
      img: chapter_3,
      subtitle: t("chapters.chapter3.subtitle"),
      detail: t("chapters.chapter3.detail"),
      darkColor: true,
    },
    {
      img: chapter_4,
      subtitle: t("chapters.chapter4.subtitle"),
      detail: t("chapters.chapter4.detail"),
      darkColor: true,
    },
  ];
  return (
    <div className="chapters">
      {dataChapter.map((item, index) => (
        <div key={index} className="chapters-section">
          <div className="title">
            <h2>{item.title}</h2>
          </div>
          <img src={item.img} alt="" />
          <div
            className={`chapters-section-info ${
              item.darkColor ? "darkColor" : ""
            }`}
          >
            <div className="title-section">{item.subtitle}</div>
            <div className="detail-section">{item.detail}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Chapters;
